var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownArrowGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 8.693,
    transform: "rotate(-180 9 8.693)",
    fill: "#48BB78",
    r: 5.786
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.733,
    cy: 9.63,
    r: 6.5,
    transform: "rotate(124 8.733 9.63)",
    fill: "#48BB78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.45 9.478a8.717 8.717 0 01-8.565 8.87 8.717 8.717 0 01-8.87-8.565A8.717 8.717 0 018.581.913a8.717 8.717 0 018.87 8.565zm-5.065-.928L9.886 11.25 9.774 4.83a.842.842 0 00-.858-.829l-.563.01a.842.842 0 00-.828.859l.112 6.418-2.592-2.61a.845.845 0 00-1.206.008l-.376.393a.84.84 0 00.02 1.192l4.743 4.583a.84.84 0 001.192-.021L14 10.087a.84.84 0 00-.02-1.192l-.39-.38a.845.845 0 00-1.206.035z",
    fill: "#C6F6D5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-180 18 20)",
    fill: "#fff",
    d: "M18 20h18v20H18z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrowGreen);
export default __webpack_public_path__ + "static/media/down-arrow-green.a0912c67fca9c6f998c28429045df7fb.svg";
export { ForwardRef as ReactComponent };